import { accessOwnerDashboard } from '~/lib/utils';

export default defineNuxtRouteMiddleware((to) => {

  // IF OWNER/TEAM
  if (accessOwnerDashboard(useUser().getUser.role) && !useUser().getUser.is_staff) {
    if (!to.path.includes('/dashboard')) {
      return navigateTo('/dashboard');
    }
    return;
  }
});
